"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const recaptcha_1 = require("./recaptcha");
const ID = "googlev2-con";
class GoogleV2 extends recaptcha_1.default {
    constructor(key) {
        super({
            src: `https://www.google.com/recaptcha/api.js?onload=onloadGoogleCallback&render=explicit`,
            key,
        });
        this.instanceID = 0;
    }
    // ----------------------------------------
    // public methods
    initialise(formEle) {
        this.addScript();
        const div = document.createElement("div");
        const total = document.querySelectorAll("[google-recaptcha]").length;
        div.setAttribute("google-recaptcha", `${total}`);
        div.id = `${ID}-${total}`;
        formEle.appendChild(div);
        this.instanceID = total;
        // @ts-ignore
        window.onloadGoogleCallback = () => {
            const recaptchaEles = document.querySelectorAll("[google-recaptcha]");
            recaptchaEles.forEach((ele) => {
                // @ts-ignore
                grecaptcha.render(ele.id, {
                    sitekey: this.key,
                    size: "invisible",
                    callback: (token) => {
                        this.setToken(token);
                    },
                });
            });
        };
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            grecaptcha.reset(this.instanceID);
            // @ts-ignore
            grecaptcha.execute(this.instanceID);
            yield this.waitUntilValid();
        });
    }
}
exports.default = GoogleV2;
